export default __webpack_public_path__ + "static/media/04-alt.21772424.png";